import React from 'react';
import reactor from 'data/reactor';
import { Immutable } from 'nuclear-js';
import PropTypes from 'prop-types';
import CreateReactClass from 'create-react-class';

import RuntimeGetters from 'data/app-runtime/getters';
import RuntimeActions from 'data/app-runtime/actions';
import { findShowMethodForModal } from 'utils/runtime';
import DataUtils from 'data/utils';
import StudentUtils from 'utils/students';
import { DeepCompareComponentShouldUpdateMixin } from 'utils/react';
import CommonValues from 'resources/common-values';

import SubjectTab from './subject-tab';

export default CreateReactClass({
    displayName: 'subject-tab-container',

    propTypes() {
        return {
            studentBid: PropTypes.string.isRequired,
            testEvents: PropTypes.instanceOf(Immutable.List).isRequired,
            selectedTermNumber: PropTypes.number.isRequired,
            highlights: PropTypes.instanceOf(Immutable.Map),
            showHighlights: PropTypes.bool.isRequired,
            toggleHighlightsFn: PropTypes.func.isRequired,
            unsavedData: PropTypes.bool,
            selectedSubject: PropTypes.instanceOf(Immutable.Map),
            currentTerm: PropTypes.instanceOf(Immutable.Map),
        };
    },

    render() {
        const termIsMostRecent =
            !this.props.selectedTermNumber || this.props.selectedTermNumber == CommonValues.mostRecentTermNumber;
        const termIsCurrent =
            !!this.props.currentTerm && this.props.selectedTermNumber == this.props.currentTerm.get('termNumber');

        const globalModalReferences = reactor.evaluate(RuntimeGetters.modalReferences);
        const showSaveDataPrompt = findShowMethodForModal(
            globalModalReferences,
            CommonValues.sharedModalReferences.saveDataPrompt
        );
        const classes = termIsCurrent || termIsMostRecent ? 'subject-tabs term-is-current' : 'subject-tabs';
        let subjectsToUse = CommonValues.subjects;
        if (__BATCH__) {
            // If we are batch-printing, we only want the current subject to be included, not all of them.
            subjectsToUse = Immutable.List.of(reactor.evaluate(RuntimeGetters.preferredSubject));
        } else {
            subjectsToUse = StudentUtils.pruneOptionalSubjectsWithNoTestEvents(this.props.testEvents);
        }
        const subjectCount = subjectsToUse.size;
        const styles = { '--visible-subjects': subjectCount };
        const subjectTabs = subjectsToUse.map((subject, index) => {
            let selectedTestEvent = null;
            if (termIsMostRecent) {
                const testEventsForSubject = DataUtils.testEventsForSubject(this.props.testEvents, subject.get('bid'));
                selectedTestEvent = DataUtils.latestItemByTerm(testEventsForSubject);
            } else {
                selectedTestEvent = DataUtils.findTestEventForTermAndSubject(
                    this.props.testEvents,
                    this.props.selectedTermNumber,
                    subject.get('bid')
                );
            }

            const testEventIsFromCurrentTerm =
                this.props.currentTerm &&
                selectedTestEvent &&
                selectedTestEvent.get('termNumber') === this.props.currentTerm.get('termNumber');
            const highlightsForSubject = this.props.highlights
                ? this.props.highlights.get(subject.get('bid', 0))
                : null;
            return (
                <SubjectTab
                    key={subject.get('shortName')}
                    studentBid={this.props.studentBid}
                    subject={subject}
                    subjectIndex={index}
                    testEvent={selectedTestEvent}
                    termIsMostRecent={termIsMostRecent}
                    termIsCurrent={termIsCurrent}
                    testEventIsCurrent={testEventIsFromCurrentTerm === true}
                    unsavedData={this.props.unsavedData}
                    clearUnsavedData={() => {
                        RuntimeActions.setUnsavedData(false);
                    }}
                    showSaveDataPrompt={showSaveDataPrompt}
                    highlights={highlightsForSubject}
                    showHighlights={this.props.showHighlights}
                    toggleHighlightsFn={this.props.toggleHighlightsFn}
                    selectedSubject={this.props.selectedSubject}
                    isFinalTab={index + 1 === subjectCount && subjectCount > 4}
                />
            );
        });

        return (
            <div className={classes} style={styles}>
                {subjectTabs}
            </div>
        );
    },
});
